import { Base } from '@studiometa/js-toolkit';
import DualRangeInput from '@stanko/dual-range-input';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * PriceRange class.
 */
export default class PriceRange extends Base {
  static config = {
    name: 'PriceRange',
    refs: ['min', 'max', 'min-value', 'max-value', 'current-value'],
    options: {
      currency: {
        type: String,
        required: true,
      },
    },
  };

  dualRangeInput = null;

  /**
   * Mounted.
   */
  mounted() {
    this.dualRangeInput = new DualRangeInput(this.$refs.min, this.$refs.max);

    this.addMinMaxValues();
    this.updateCurrentValues();
  }

  /**
   * Add min and max values
   */
  addMinMaxValues() {
    this.$refs.minValue.innerHTML = `${this.$refs.min.min}${this.$options.currency}`;
    this.$refs.maxValue.innerHTML = `${this.$refs.max.max}${this.$options.currency}`;
  }

  /**
   * Update current value
   */
  updateCurrentValues() {
    this.$refs.currentValue.innerHTML = `${this.$refs.min.value}${this.$options.currency} - ${this.$refs.max.value}${this.$options.currency}`;
  }

  /**
   * onMaxInput
   */
  onMaxInput() {
    this.updateCurrentValues();
  }

  /**
   * onMinInput
   */
  onMinInput() {
    this.updateCurrentValues();
  }

  onMaxMousedown() {
    addClass(this.$refs.max, '!tw-cursor-grabbing');
  }

  onMaxMouseup() {
    removeClass(this.$refs.max, '!tw-cursor-grabbing');
  }

  onMinMousedown() {
    addClass(this.$refs.min, '!tw-cursor-grabbing');
  }

  onMinMouseup() {
    removeClass(this.$refs.min, '!tw-cursor-grabbing');
  }

  destroyed() {
    this.dualRangeInput.destroy();
    this.dualRangeInput = null;
  }
}
